import new_1_thumb from './b-lite-thumbnail.jpg';
import new_1_img_1 from './b-lite-1-before.png';
import new_1_img_2 from './b-lite-1-after.png';
import new_1_img_3 from './b-lite-2-before.jpg';
import new_1_img_4 from './b-lite-2-after.jpg';
import new_2_img_1 from './bichat-1.png';
import new_2_img_2 from './bichat-2.jpg';
import new_2_img_3 from './bichat-3.png';

export default [
  undefined,
  new_1_thumb, new_1_img_1, new_1_img_2, new_1_img_3, new_1_img_4,
  new_2_img_1, new_2_img_2, new_2_img_3
]



// WEBPACK FOOTER //
// ./src/assets/img/novinky/index.js